// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SearchProps {}

export enum SearchType {
    invoice_number = 'invoiceNumber',
    mawb = 'mawb',
}
